export const PAST_DATE_KEYS = ["lastWeek", "lastMonth", "lastQuarter", "lastYear"];
